var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1367 4.30371C16.1367 4.47949 16.1367 4.62012 16.1367 4.7959C16.1367 9.68262 12.4453 15.2725 5.66016 15.2725C3.55078 15.2725 1.61719 14.6748 0 13.6201C0.28125 13.6553 0.5625 13.6904 0.878906 13.6904C2.60156 13.6904 4.18359 13.0928 5.44922 12.1084C3.83203 12.0732 2.46094 11.0186 2.00391 9.54199C2.25 9.57715 2.46094 9.6123 2.70703 9.6123C3.02344 9.6123 3.375 9.54199 3.65625 9.47168C1.96875 9.12012 0.703125 7.64355 0.703125 5.85059V5.81543C1.19531 6.09668 1.79297 6.2373 2.39062 6.27246C1.37109 5.60449 0.738281 4.47949 0.738281 3.21387C0.738281 2.51074 0.914062 1.87793 1.23047 1.35059C3.05859 3.56543 5.80078 5.04199 8.85938 5.21777C8.78906 4.93652 8.75391 4.65527 8.75391 4.37402C8.75391 2.33496 10.4062 0.682617 12.4453 0.682617C13.5 0.682617 14.4492 1.10449 15.1523 1.84277C15.9609 1.66699 16.7695 1.35059 17.4727 0.928711C17.1914 1.80762 16.6289 2.51074 15.8555 2.96777C16.5938 2.89746 17.332 2.68652 17.9648 2.40527C17.4727 3.14355 16.8398 3.77637 16.1367 4.30371Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.16506dc0619cc24ddf3bc67d24ab8605.svg";
export { ForwardRef as ReactComponent };